<template>
  <div>
      <div class="com-page-title">
        <div class="inner">{{ $route.meta.title }}</div>
      </div>
      <div class="com-card">
        <div class="com-card-title">功德主信息</div>
        <div class="com-card-content">
          <div class="com-form-wrap">
            <van-form class="com-form-vertical" ref="form">
              <van-field
                v-model="form.name"
                :border="false"
                label="功德主姓名"
                :placeholder="payload.pageData.id == 297 ? '示例：XXX或XXX全家' : '示例：XXX,XXX,XXX或XXX全家'"
                :rules="[{ required: true, trigger: 'onBlur', message: '请填写供奉人' }]"
              >
                <template #left-icon>{{ payload.pageData.id == 297 ? '限一人或一人及全家' : '限三人或一人及全家' }}</template>
              </van-field>
              <van-field
                v-model="form.mobile"
                :border="false"
                label="联系方式"
                placeholder="请填写手机号码"
                :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
              />
              <van-field
                v-if="isPray"
                v-model="form.sentence.dictLabel"
                class="field-yellow"
                readonly
                clickable
                colon
                label="祈福语选择"
                placeholder="请选择书写祝福语"
                @click="showPicker = true"
              />
            </van-form>
          </div>
        </div>
      </div>
      <div class="com-card">
        <div class="com-card-title">详情</div>
        <div class="com-card-content">
          <div class="text-wrap">
            <p>在线护持 - {{ payload.pageData?.name }}</p>
            <p>¥{{ payload.price }} x {{ payload.quantity }}<span v-if="[2, 4].includes(payload.type)">/对</span></p>
          </div>
        </div>
      </div>
      <div class="com-card">
        <div class="com-card-title">合计</div>
        <div class="com-card-content">
          <div class="text-wrap">
            <p class="t2">¥{{ payload.price * payload.quantity }}</p>
          </div>
          <div class="com-form-submit">
            <DefaultBtn @click="pay">支付</DefaultBtn>
          </div>
        </div>
      </div>
  </div>
  <!-- 文殊智慧灯笼 -->
  <Dictionary typeCode="wenshuzhihui" :show="showPicker" :selectDict="selectSentence" v-if="payload.pageData.id == 264"/>
  <!-- 新春祈福灯笼 -->
  <Dictionary typeCode="xinchunqifu" :show="showPicker" :selectDict="selectSentence" v-else-if="payload.pageData.id == 267"/>
  <!-- 观音祈福卡 -->
  <Dictionary typeCode="guanyinqifu" :show="showPicker" :selectDict="selectSentence" v-else-if="payload.pageData.id == 270"/>
  <!-- 平安灯笼祈福语 -->
  <Dictionary typeCode="pingandenglongqifu" :show="showPicker" :selectDict="selectSentence" v-else-if="payload.pageData.id == 314"/>
</template>

<script>
  import Dictionary from '@/components/common/Dictionary'
  const form = {
    name: null,
    mobile: null,
    blessingWords: null,
    sentence: {
      dictLabel: null,
    }
  }
  import { WxPay } from '@/utils/Pay'
  export default {
    data () {
      return {
        form: {
          ...form
        },
        showPicker: false,
        payload: {
          pageData: {
            name: ''
          }
        }
      }
    },
    mounted () {
      this.getPreData()
    },
    methods: {
      // 支付
      pay () {

        this.$refs.form.validate().then(err => {
          if (!err) {
            const form = {
              liveList: [this.form],
              // 广种福田订单
              type: 3,
              // 后台管理订单详情里面后到
              orderType: JSON.stringify({
                key: 'fawu-futian',
                // 类型 0 随喜金额和祈福  2纪念日   3功德林
                type: this.payload.type,
                pId: this.payload.pageData.id,
                gongdengdiantang: this.payload.gongdengdiantang,
                treeId: this.payload.id,
                anniversaryId: this.payload.id
              }),
              blessingWords: this.form.sentence.dictLabel,
              categoryId: this.payload.pageData.id,
              // 商品id
              goodsId: this.payload.pageData.goodId,
              // 支付类型
              payWay: 'JSAPI',
              addWechat: 0,
              goodsNum: this.payload.quantity,
              orderPrice: this.payload.price * this.payload.quantity,
              // orderPrice: 0.01
            }
            // 微信支付，因为该商户为子商户，没有回调功能，支付成功就完事了。。。
            new WxPay(form, data => {
              if (data.orderStatus) {
                this.$router.push('/pay/success')
              }
            })
          }
        }).catch (() => {
          this.$toast('请填写登记信息')
        })
      },
      // 祈福语选择
      selectSentence (v) {
        if (v) {
          this.form.sentence = v
        }
        this.showPicker = false
      },
      // 获取上一级参数
      getPreData () {
        const preData = JSON.parse(localStorage.getItem(this.$route.query.timestamp))
        this.payload = {
            ...preData,
          // 类型 0 一级  2纪念日   3功德林
          // type: preData.type,
          // 一级Id
          // pId: preData.pId,
          // 二级id，纪念日&功德林用的到
          // id: preData.pageData.id,
          // 数量
          quantity: preData.quantity,
          // 单价
          price: Number(preData.price),
        }
      }
    },
    computed: {
      // 是否为祈福项目
      isPray () {
        return [264, 267, 270, 314].includes(this.payload.pageData.id)
      }
    },
    components: {
      Dictionary
    }
  }
</script>